import { isValid, parseISO } from 'date-fns'
import { formatDate, formatDateOnly } from 'helpers/string'
import { mapValues } from 'lodash'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs'

const isoDateTimeRegexp =
  /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/

const isISODateString = (str: string) => {
  try {
    return isoDateTimeRegexp.test(str) && isValid(parseISO(str))
  } catch (err) {
    return false
  }
}

interface RawJsonDisplayProps {
  json: string
}

const RawJsonDisplay = ({ json }: RawJsonDisplayProps) => {
  const obj = JSON.parse(json)

  const formattedObj = mapValues(obj, (val) => {
    if (isISODateString(val)) {
      return val.length === 10 ? formatDateOnly(val) : formatDate(val)
    }

    return val
  })

  return (
    <SyntaxHighlighter language="json" style={github}>
      {JSON.stringify(formattedObj, null, 2)}
    </SyntaxHighlighter>
  )
}

export default RawJsonDisplay
